import { GET_QUOTA_TYPES } from './actionsTypes'

const initialState = {
  quotaTypes: {},
}

const quotaData = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_QUOTA_TYPES:
      return {
        ...state,
        quotaTypes: payload,
      }
    default:
      return state
  }
}

export default quotaData
